module.exports = {
  AvatarPlayer: {
    PluginName: "Avatar",
    avatar: "Avatar",
    avatarName: "Avatar name",
    poster: "Image",
    framing: "Framing",
    focalX: "Horizontal focus",
    focalY: "Vertical focus",
    radius: "Corner radius",
    box_style: "Box style",
    border: "Border",
    opacity: "Opacity",
  },
};
